<template>
	<v-card>
		<v-card-text>
			<v-form ref="formActual">
				<v-layout row wrap>
					<v-flex xs12 md3 text-h5 pt-4 pl-5>
						SUBJETIVO
					</v-flex>
					<v-flex xs12 md6>
						<v-textarea
							v-model="valor.Subjetivo"
							:rules="[!!valor.Subjetivo || 'Campo Obligatorio']"
							rows="3"
							outlined
							class="campo-formulario"
						>
						</v-textarea>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12 md3 text-h5 pt-4 pl-5>
						OBJETIVO
					</v-flex>
					<v-flex xs12 md6>
						<div class="font-weight-bold">Antropométricos</div>
						<v-textarea
							rows="3"
							outlined
							readonly
							class="campo-formulario"
						></v-textarea>
						<div class="font-weight-bold">Bioquímicos</div>
						<v-textarea
							rows="3"
							outlined
							readonly
							class="campo-formulario"
						></v-textarea>
						<div class="font-weight-bold">Clínicos</div>
						<v-textarea
							v-model="valor.Clinicos"
							:rules="[!!valor.Clinicos || 'Campo Obligatorio']"
							rows="3"
							outlined
							class="campo-formulario"
						></v-textarea>
						<div class="font-weight-bold">Dietéticos</div>
						<v-textarea
							v-model="valor.Dieteticos"
							:rules="[!!valor.Dieteticos || 'Campo Obligatorio']"
							rows="3"
							outlined
							class="campo-formulario"
						></v-textarea>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12 md3 text-h5 pt-4 pl-5>
						ANÁLISIS
					</v-flex>
					<v-flex xs12 md6>
						<div class="font-weight-bold">
							Requerimientos energéticos
						</div>
						<v-textarea
							rows="3"
							outlined
							readonly
							class="campo-formulario"
						></v-textarea>
						<div class="font-weight-bold">
							Diagnóstico nutricional
						</div>
						<v-textarea
							rows="3"
							outlined
							v-model="valor.DiagnosticoNutricional"
							:rules="[
								!!valor.DiagnosticoNutricional ||
									'Campo Obligatorio'
							]"
							class="campo-formulario"
						></v-textarea>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12 md3 text-h5 pt-4 pl-5>
						PLAN
					</v-flex>
					<v-flex xs12 md6>
						<div class="font-weight-bold">
							Plan de alimentación
						</div>
						<v-textarea
							rows="3"
							outlined
							readonly
							class="campo-formulario"
						></v-textarea>
						<div class="font-weight-bold">Recomendaciones</div>
						<v-textarea
							rows="3"
							outlined
							v-model="valor.Recomendaciones"
							:rules="[
								!!valor.Recomendaciones || 'Campo Obligatorio'
							]"
							class="campo-formulario"
						></v-textarea>
						<div class="font-weight-bold">Educación</div>
						<v-textarea
							rows="3"
							outlined
							v-model="valor.Educacion"
							:rules="[!!valor.Educacion || 'Campo Obligatorio']"
							class="campo-formulario"
						></v-textarea>
						<div class="font-weight-bold">Monitoreo</div>
						<v-textarea
							rows="3"
							outlined
							v-model="valor.Monitoreo"
							:rules="[!!valor.Monitoreo || 'Campo Obligatorio']"
							class="campo-formulario"
						></v-textarea>
					</v-flex>
				</v-layout>
			</v-form>
		</v-card-text>
		<v-footer app class="pt-3 d-print-none">
			<v-btn color="secondary" x-large @click.prevent="regresar"
				>Regresar <v-icon>chevron_left</v-icon></v-btn
			>
			<v-spacer></v-spacer>
			<v-btn color="primary" x-large @click.prevent="guardar"
				><v-icon>save</v-icon> Guardar
			</v-btn>
		</v-footer>
	</v-card>
</template>

<script>
import ServicioVisita from "../../../services/visita";
export default {
	name: "notaEvolucionInterna",
	data() {
		return {
			valor: {}
		};
	},
	async mounted() {
		await this.obtenerInfoPaso();
	},
	methods: {
		async obtenerInfoPaso() {
			const nombrePaso = "NotaEvolucionInterna";
			const res = await ServicioVisita.obtenerInfoPaso(
				nombrePaso,
				this.visitaId
			);
			if (res.data.result === 1 && res.data.data.Table0.length) {
				const valor = JSON.parse(res.data.data.Table0[0][nombrePaso]);
				if (valor) this.valor = valor;
			}
		},
		regresar() {
			this.$router.back();
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioVisita.guardarNotaEvolucionInterna(
					this.visitaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.regresar();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		}
	},
	computed: {
		visitaId() {
			return this.$route.params.visitaId;
		}
	}
};
</script>

<style></style>
